module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-col', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择创意组合名称"
    },
    model: {
      value: (_vm.pdata.creative_bale_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "creative_bale_id", $$v)
      },
      expression: "pdata.creative_bale_id"
    }
  }, _vm._l((_vm.creativeGroupList), function(item, i) {
    return _c('el-option', {
      key: item.creativebale_id,
      attrs: {
        "label": item.name,
        "value": item.creativebale_id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search  xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品名称/创意名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择产品状态"
    },
    model: {
      value: (_vm.pdata.status),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "status", $$v)
      },
      expression: "pdata.status"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "选择产品状态",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    key: "0",
    attrs: {
      "label": "禁用",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "1",
    attrs: {
      "label": "启用",
      "value": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "广告主游戏",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editProduct(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "产品来源",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.source == 1) ? _c('span', [_vm._v("互导")]) : _vm._e(), _vm._v(" "), (scope.row.source == 2) ? _c('span', [_vm._v("卖量")]) : _vm._e(), _vm._v(" "), (scope.row.source == 3) ? _c('span', [_vm._v("测量")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "box_name",
      "label": "中转盒子",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "创意个数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.creative_num.ok) + "/" + _vm._s(scope.row.creative_num.count))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "path",
      "label": "产品路径",
      "width": "250px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "更新时间",
      "width": "220px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "​产品状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.status == 1 ? '启用' : '禁用'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "width": "250px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.editStatus(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '创意投放日志',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  type: 'creative'
                }
              })
            }
          }
        }, [_vm._v("更新日志")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增创意' : '编辑创意',
      "visible": _vm.editDialog,
      "width": "950px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请选择中转盒子",
      "prop": "jump_type"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请从产品管理里选择产品",
      "disabled": _vm.isAdd ? false : true
    },
    model: {
      value: (_vm.chooseProduct.issued_app_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "issued_app_id", $$v)
      },
      expression: "chooseProduct.issued_app_id"
    }
  }, _vm._l((_vm.baleBoxList), function(item) {
    return _c('el-option', {
      key: item.issued_app_id,
      attrs: {
        "label": item.name,
        "value": item.issued_app_id,
        "default-first-option": ""
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品选择",
      "prop": "product_base_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请从产品管理里选择产品",
      "disabled": _vm.isAdd ? false : true
    },
    model: {
      value: (_vm.chooseProduct.product_base_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "product_base_id", $$v)
      },
      expression: "chooseProduct.product_base_id"
    }
  }, _vm._l((_vm.productList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.product_base_id,
        "default-first-option": ""
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "myItems",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "",
      "prop": "data"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("创意名称")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("创意权重")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("创意帧数")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("角标")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "0  0 10px 0"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("操作")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "myItems",
    attrs: {
      "label": "",
      "prop": "data"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "120px",
      "display": "inline-block"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addCreative(true)
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _vm._l((_vm.chooseProduct.data), function(item, index) {
    return _c('div', {
      class: item.isAdd ? 'add' : 'edit'
    }, [(!item.isAdd) ? _c('div', {}, [_c('img', {
      attrs: {
        "src": item.icon_url
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(item.rename))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editCreative(index)
        }
      }
    }, [_vm._v("编辑")])], 1) : _c('div', [_c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 5
      }
    }, [_c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("\n\t\t     \t\t\t\n\t\t     \t\t\t \t\t" + _vm._s(index + 1) + ":\n\t\t     \t\t\t \t")]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入创意名称",
        "clearable": ""
      },
      model: {
        value: (item.rename),
        callback: function($$v) {
          _vm.$set(item, "rename", $$v)
        },
        expression: "item.rename"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入创意权重",
        "clearable": ""
      },
      model: {
        value: (item.weight),
        callback: function($$v) {
          _vm.$set(item, "weight", $$v)
        },
        expression: "item.weight"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 3
      }
    }, [_c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请输入创意帧数",
        "clearable": ""
      },
      model: {
        value: (item.frame),
        callback: function($$v) {
          _vm.$set(item, "frame", $$v)
        },
        expression: "item.frame"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [_c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "请选择角标"
      },
      model: {
        value: (item.heat),
        callback: function($$v) {
          _vm.$set(item, "heat", $$v)
        },
        expression: "item.heat"
      }
    }, [_c('el-option', {
      key: "0",
      attrs: {
        "label": "无",
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "1",
      attrs: {
        "label": "红点",
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "2",
      attrs: {
        "label": "热门",
        "value": "2"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "3",
      attrs: {
        "label": "New",
        "value": "3"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "4",
      attrs: {
        "label": "感叹号",
        "value": "4"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 5
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": item.status == '1' ? 'success' : 'danger'
      },
      on: {
        "click": function($event) {
          return _vm.changeCreative(index)
        }
      }
    }, [_vm._v(_vm._s(item.status == '1' ? '正常' : '禁用'))])], 1)], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 5
      }
    }, [_c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 4
      }
    }, [_c('UploadImg', {
      attrs: {
        "image": item.icon_url,
        "url": _vm.url + 'creative/icon'
      },
      on: {
        "update:image": function($event) {
          return _vm.imageUploadSuccess($event, index)
        }
      }
    }), _vm._v(" "), _c('el-input', {
      staticClass: "input",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !item.isAdd,
        "placeholder": "请输入图片名称",
        "clearable": ""
      },
      model: {
        value: (item.icon_name),
        callback: function($$v) {
          _vm.$set(item, "icon_name", $$v)
        },
        expression: "item.icon_name"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "0  0 10px 0"
      },
      attrs: {
        "span": 17
      }
    }, [(_vm.creativeIconList.length > 0) ? _c('ul', {
      staticClass: "iconImgList"
    }, [_vm._l((_vm.creativeIconList), function(it, idx) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.copyIconImage(it, index)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": it.url
        }
      })])
    }), _vm._v(" "), _c('li', [_vm._v("推荐Icon")])], 2) : _vm._e()])], 1)], 1)])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57635e9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adControl/CreativeGroup.vue
// module id = 1106
// module chunks = 2